import * as Types from '../../../graphql/generated';

import { DocumentNode } from 'graphql';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';

export type WorkspaceForCardQueryVariables = {
  shortLinkOrId: Types.Scalars['ID'];
};


export type WorkspaceForCardQuery = (
  { __typename: 'Query' }
  & { card?: Types.Maybe<(
    { __typename: 'Card' }
    & Pick<Types.Card, 'id'>
    & { board: (
      { __typename: 'Board' }
      & Pick<Types.Board, 'idOrganization'>
    ) }
  )> }
);


export const WorkspaceForCardDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WorkspaceForCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shortLinkOrId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shortLinkOrId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idOrganization"},"arguments":[],"directives":[]}]}}]}}]}}]};

/**
 * __useWorkspaceForCardQuery__
 *
 * To run a query within a React component, call `useWorkspaceForCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceForCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceForCardQuery({
 *   variables: {
 *      shortLinkOrId: // value for 'shortLinkOrId'
 *   },
 * });
 */
export function useWorkspaceForCardQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WorkspaceForCardQuery, WorkspaceForCardQueryVariables>) {
        return ApolloReactHooks.useQuery<WorkspaceForCardQuery, WorkspaceForCardQueryVariables>(WorkspaceForCardDocument, baseOptions);
      }
export function useWorkspaceForCardLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WorkspaceForCardQuery, WorkspaceForCardQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<WorkspaceForCardQuery, WorkspaceForCardQueryVariables>(WorkspaceForCardDocument, baseOptions);
        }
export type WorkspaceForCardQueryHookResult = ReturnType<typeof useWorkspaceForCardQuery>;
export type WorkspaceForCardLazyQueryHookResult = ReturnType<typeof useWorkspaceForCardLazyQuery>;
export type WorkspaceForCardQueryResult = ApolloReactCommon.QueryResult<WorkspaceForCardQuery, WorkspaceForCardQueryVariables>;